import type { ComponentProps } from 'react';
import { ModalLink } from '@inertiaui/modal-react';

import { useIsClient } from '@/hooks/use-is-client';

type ModalButtonProps = ComponentProps<typeof ModalLink>;

function renderChildren(children: ModalButtonProps['children']) {
  return typeof children === 'function' ? children({ loading: false }) : children;
}

export default function ModalButton({ children, ...props }: ModalButtonProps) {
  const isClient = useIsClient();
  const { href: _href, ...buttonProps } = props;

  if (!isClient) {
    return (
      <button type="button" {...buttonProps}>
        {renderChildren(children)}
      </button>
    );
  }

  return (
    <ModalLink as="button" {...props}>
      {children}
    </ModalLink>
  );
}
